import React from 'react';

function Alert({ show, type, message, onClose }) {
  if (!show) return null;

  const alertStyles = {
    success: {
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      color: 'white',
      border: 'none',
      boxShadow: '0 4px 15px rgba(102, 126, 234, 0.4)'
    },
    danger: {
      background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
      color: 'white',
      border: 'none',
      boxShadow: '0 4px 15px rgba(245, 87, 108, 0.4)'
    }
  };

  return (
    <div 
      className="alert alert-dismissible fade show position-fixed top-0 start-50 translate-middle-x mt-3"
      role="alert"
      style={{ 
        zIndex: 9999, 
        minWidth: '300px', 
        maxWidth: '600px',
        ...alertStyles[type]
      }}
    >
      <i className={`fas fa-${type === 'success' ? 'check-circle' : 'exclamation-circle'} me-2`}></i>
      <strong>{message}</strong>
      <button type="button" className="btn-close btn-close-white" onClick={onClose}></button>
    </div>
  );
}

export default Alert;